//getadmin Actions
export const GET_ADMIN_SUCCESS = "GET_ADMIN_SUCCESS";
export const GET_ADMIN_ERROR = "GET_ADMIN_ERROR";

//updateadmin Actions
export const UPDATE_ADMIN_SUCCESS = "UPDATE_ADMIN_SUCCESS";
export const UPDATE_ADMIN_ERROR = "UPDATE_ADMIN_ERROR";
